module.exports = __webpack_public_path__ + "static/media/upgrade-dialog-banner.a113540a.png";